import { createContext } from 'react';
import { QUERY_KEYS_BENEFITS, useChartsData } from '../../../../Common/hooks/useChartsData';
import { useIgdFiltersContext } from '../../../Common/Filters/hooks/useIgdFiltersContext';

export const BasicBenefitsChartsDataContext = createContext();

const BasicBenefitsChartsDataProvider = ({ children }) => {

    const { filters } = useIgdFiltersContext();

    const filtersParams = {
        year: filters?.year?.value ?? '',
        month: filters?.month?.value ?? '',
        location: filters?.unidade?.value ?? '',
        city: filters?.cidade?.value ?? ''
    };

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_BENEFITS.BENEFITS_OTHER_BENEFITS_VALUES,
            url: 'governanceroom/socialdashboard/benefits/otherBenefits/values',
        },
        filtersParams
    );

    const averageValuesQuery = useChartsData(
        {
            key: QUERY_KEYS_BENEFITS.BENEFITS_OTHER_BENEFITS_AVERAGE_VALUES,
            url: 'governanceroom/socialdashboard/benefits/otherBenefits/averageValues',
        },
        filtersParams
    );

    const chartData = {
        values: {
            annual: data?.anualEvolution ?? [],
            monthly: data?.monthEvolution ?? []
        },

        averageValues: {
            annual: averageValuesQuery.data?.anualEvolution ?? [],
            monthly: averageValuesQuery.data?.monthEvolution ?? []
        }
    };

    return (
        <BasicBenefitsChartsDataContext.Provider
            value={{
                chartData,
                filters,
                filterParams: filtersParams,
                isLoading,
                isError,
                data
            }}
        >
            {children}
        </BasicBenefitsChartsDataContext.Provider>
    );
};

export default BasicBenefitsChartsDataProvider;
